'use client';

import { useEffect, useMemo } from 'react';

import { TooltipFloatingContext } from './context/tooltip-floating.context';
import { TooltipRootContext } from './context/tooltip-root.context';
import { useTooltip } from './hooks/use-tooltip';
import type { TooltipRootPropsInterface } from './types/tooltip-root.types';

/**
 * @since 10.0.0
 */
export const TooltipRoot = (props: TooltipRootPropsInterface) => {
  const { children, forceUpdateDependency, ...rest } = props;

  const { tooltip, floating } = useTooltip(rest);

  useEffect(() => {
    floating.context.update();
  }, [floating.context, forceUpdateDependency]);

  const contextValue = useMemo(() => ({ tooltip }), [tooltip]);

  return (
    <TooltipRootContext.Provider value={contextValue}>
      <TooltipFloatingContext.Provider value={floating}>{children}</TooltipFloatingContext.Provider>
    </TooltipRootContext.Provider>
  );
};

TooltipRoot.displayName = 'Tooltip.Root';
